import { StepMock } from '@interfaces/mock.interface';

import { EdpWarningMock } from '../../mocks-handler/mocks/edp-warning.mock';

export const MOCKS_SCORING = [
    {
        key: 'KO',
        label: 'Scoring KO',
        data: {
            global: {
                ligneMarcheFnb: {
                    forfaitData: {
                        message: 'La Gamme FAIM est inaccessible pour ce client.',
                    },
                    voixAvecEngagement: {
                        message: 'La Gamme Premium avec téléphone est inaccessible pour ce client.',
                    },
                    voixSansEngagement: {
                        message: 'La Gamme Premium sans téléphone ET sans engagement est inaccessible pour ce client.',
                    },
                },
                ligneMarcheFai: {
                    fai: {
                        message: 'Attention : l’offre 4G Box est inaccessible pour ce client.',
                        estDisponible: true,
                    },
                },
            },
            detaille: {
                controleImpaye: {
                    message:
                        "Une de vos lignes semble être en situation d'impayé.</br> Régularisez votre situation sur votre Espace Client. Vous pourrez passer commande 48h après avoir effectué votre règlement.",
                    estForcable: false,
                    action: {
                        type: 'lien',
                        text: 'Régulariser ma situation',
                        target: 'https://www.bouyguestelecom.fr/mon-compte/',
                    },
                },
            },
        },
    },
    {
        key: 'OK',
        label: 'Scoring OK',
        data: { global: {}, detaille: {} },
    },
    {
        key: 'KO_EDP',
        label: 'KO pour EDP',
        data: {
            global: {
                edp: {
                    edp: {
                        message: 'EDP acquisition mobile : Nombre max d’EDP atteint.',
                    },
                },
            },
            detaille: {
                eligibiliteEDP: {
                    message:
                        "Vous avez atteint le nombre maximum de possibilités d'étalement de paiement.</br>Veuillez sélectionner une solution de paiement au comptant pour poursuivre votre commande.",
                    estForcable: true,
                    action: {
                        type: 'supprimerEdp',
                    },
                },
            },
        },
    },
];

export const PAYMENT_MOCKS: StepMock[] = [
    {
        url: '/ventes/scoring',
        mocks: MOCKS_SCORING,
    },
    {
        url: '/ventes/paniers/modes-financements',
        mocks: [EdpWarningMock],
    },
];
